import { Spinner, Stack } from "react-bootstrap"

const Loading = () => {
    return <div style={{margin:"auto", display: "inline-block"}}><Stack  gap={1} direction="horizontal">
        <Spinner animation="grow" size="sm"/>
        <Spinner animation="grow" size="sm"/>
        <Spinner animation="grow" size="sm"/>
    </Stack></div>
}

export default Loading
